import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";
import { Aliment } from "../aliments/Aliment";

export const Ingredient = Object.freeze({
  _id: {
    visibleName: "Ingrediente",
    type: InputTypes.SELECT_WITH_PLACEHOLDER,
    optionsMapping: {
      defaultValue: "Seleccione uno...",
      source: OptionsSources.COLLECTION,
      collection: Aliment,
      property: Aliment._id,
      visibleProperty: Aliment.food_name.composedElements.nameES,
      filter: () => {
        return true;
      },
    },
  },
  ingredient_preparation: {
    visibleName: "Preparación adicional",
    type: InputTypes.TEXT_AREA,
  },
  min_amount: {
    visibleName: "Cantidad mínima",
    type: InputTypes.NUMBER,
    min: 0,
  },
  max_amount: {
    visibleName: "Cantidad máxima",
    type: InputTypes.NUMBER,
    min: 0,
  },
  units: {
    visibleName: "Unidades",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: [],
    },
  },
  is_variable: {
    visibleName: "Variable",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  is_visible: {
    visibleName: "Visible",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  priority_weight: {
    visibleName: "Peso de prioridad",
    type: InputTypes.NUMBER,
    min: 0,
  },
});

export const SpecificIngredient = (ingredientType) => {
  let specificIngredient = JSON.parse(JSON.stringify(Ingredient));

  specificIngredient._id.optionsMapping.filter = (ingredient) => {
    return ingredient?.nutrient_group === ingredientType;
  };

  return specificIngredient;
};
